export default config => {
  const {
    mock = process.env.NODE_ENV === 'development',
    setup
  } = config;
  if (mock === false) return;
  setup();
};